import i18n from '@/lang/i18n'
import { today, lastMonth } from '../utils'
// --------- method ---------
export const newEnum = (descriptions) => {
  const result = {}
  Object.keys(descriptions).forEach((description) => {
    result[result[description] = descriptions[description]] = description
  })
  return Object.freeze(result)
}
export const enumToArr = (obj) => {
  return Object.values(obj).slice(0, Object.keys(obj).length / 2)
}
// filter 的 options
const arrayToFilterOptions = (structure, startFrom = 0) => {
  return structure.map((item, index) => {
    return {
      value: startFrom + index,
      label: item
    }
  })
}
// --------- 後端御霖提供的資料格式 ---------
/*
    0=常態數據資料(用電度數、天氣、發電量)
    1=低程度通知(訪客通知、大門未關警報、黑名單)
    2=中程度警報(不造成災害設備故障如:發電機、空調、照明燈、門禁設備故障)
    3=高程度警報(水塔滿水、電梯故障)
    4=災難等級警報(火災、地震、淹水)
    */
export const TagLevelZh = [
  '-',
  'L1-低程度警報',
  'L2-中程度警報',
  'L3-高程度警報',
  'L4-災害級警報']
// 選擇用
const TagLevelOptionStructure = TagLevelZh.slice(1)
// Tag Status -1 為沒有 Log 的狀態下無法判斷該 Tag 為正常或異常的預設值
// ---------- TAB1 ----------
// 【API】 - 這邊一支 API ，餵查詢條件、略過幾則、需要幾則，獲取事件列表
//  當前事件列表之欄位結構
export const eventStructure = Object.freeze({

  CreatedTime: '事件發生時間',
  DoneTime: '事件結案時間',
  Duration: '持續時間',
  TagLevel: '告警等級',
  TagMean: '告警訊息',
  AssetCategory: '設備類別',
  TagName: '點位名稱',
  AssetName: '設備名稱',
  AssetPosition: '存放位置',
  IsPrivate: '區域',
  EventStatus: '告警狀態',
  CurrentStageType: '處理狀態',
  CurrentStageRemark: '處理備註'
})
// 事件處理狀態顯示用（全）
export const eventStageType = ['未處理', '處理中', '人工結案', '系統結案', '住戶結案']
// 事件處理狀態人工回報選項（已處理 => 人工結案）
export const eventStageTypeForReport = [
  i18n.t('BAAlert.Unprocessed'), // 未處理
  i18n.t('BAAlert.Processing') // 處理中
]
/**
 * 事件服務類型列舉
 * @enum {number}
 */
export const EventServiceType = Object.freeze({
  Unspecified: 1, // 未指定服務
  IntercomEmergencyCall: 2 // 對講機-緊急通話
})
/**
 * 取得事件處理狀態人工回報選項
 * @param {boolean} canResolveByAdmin - 是否可由管理員結案
 * @returns {Array} 事件處理狀態選項
 */
export const getEventStageTypeForReport = (canResolveByAdmin) => {
  const eventStageTypeForReportCopy = [...eventStageTypeForReport]
  // 若可由管理員結案，則加入「已處理」選項
  if (canResolveByAdmin) {
    eventStageTypeForReportCopy.push(i18n.t('BAAlert.Processed'))
  }
  return eventStageTypeForReportCopy
}
export const eventAreaList = ['請選擇', '公區', '私區']
// 查詢功能的結構
export const eventFilterStructure = [
  {
    label: eventStructure.AssetName,
    name: 'AssetName',
    type: 'input'
  },
  {
    label: eventStructure.TagName,
    name: 'TagName',
    type: 'input'
  },
  {
    label: eventStructure.AssetPosition,
    name: 'AssetPosition',
    type: 'input'
  },
  {
    label: eventStructure.AssetCategory,
    name: 'AssetCategoryId',
    type: 'cascader',
    options: [],
    value: '',
    isDisable: true
  },
  {
    label: eventStructure.TagLevel,
    name: 'TagLevelList',
    type: 'multiselect',
    options: arrayToFilterOptions(TagLevelOptionStructure, 1),
    value: ''
  },
  {
    label: eventStructure.CurrentStageType,
    name: 'StageTypeList',
    type: 'multiselect',
    options: arrayToFilterOptions(eventStageType),
    value: ''
  },
  {
    label: '發生時間',
    name: 'duration',
    type: 'date',
    value: [lastMonth, today],
    required: true
  },
  {
    label: '區域',
    name: 'IsPrivate',
    type: 'select',
    options: [
      { value: 'null', label: '請選擇' },
      { value: 'false', label: '公區' },
      { value: 'true', label: '私區' }
    ],
    value: null
  }
]
// 【API】 - 這邊一支 API ，餵事件 Id、處理狀態、處理備註、回報人、回報時間，送出事件回報紀錄
// 事件回報
export const eventReportStructure = Object.freeze({
  CreatedTime: '發生時間',
  TagLevel: eventStructure.TagLevel,
  TagMean: eventStructure.TagMean,
  TagName: eventStructure.TagName,
  AssetPosition: '位置',
  EventStatus: '告警狀態',
  CurrentStageType: eventStructure.CurrentStageType,
  CurrentStageRemark: eventStructure.CurrentStageRemark
})
// 【API】 - 這邊一支 API ，餵事件 Id，獲取事件歷史處理進度（含事件產生時的未處理記錄）、系統日誌
// 事件詳情
export const eventDetailStructure = Object.freeze({
  CreatedTime: '發生時間',
  TagLevel: eventStructure.TagLevel,
  TagMean: eventStructure.TagMean,
  TagName: eventStructure.TagName,
  AssetPosition: '位置',
  EventStatus: '告警狀態',
  VideoBtn: '告警連動影片',
  History: '歷史處理進度',
  Log: '系統日誌'
})
// 歷史處理進度結構
export const eventReportHistoryStructure = Object.freeze({
  TypeFromTo: '處理狀態',
  ReportedTime: '回報時間',
  Remark: '處理備註',
  Reporter: '回報人'
})
// 系統日誌結構
export const simpleLogStructure = Object.freeze({
  Status: '點位狀態',
  WarningTime: '偵測時間',
  HasVideo: '告警連動影片',
  videoExpiredTime: '影片過期時間',
  Remark: '備註'
})
// 影片按鈕狀態
export const videoBtnStatus = Object.freeze({
  hasVideo: 'hasVideo',
  noVideo: 'noVideo',
  expired: 'expired'
})
// ---------- TAB 2 ----------
// 【API】 - 這邊一支 API ，餵查詢條件、略過幾則、需要幾則，獲取點位列表
// 【API】 - 這邊一支 API ，最高權限管理員可以設定推播開關
// 管理列表結構
export const managementStructure = Object.freeze({

  AssetName: '設備名稱',
  AssetPosition: '存放位置',
  AssetCategory: '設備類別',
  Name: '點位名稱',
  Mean: '告警訊息',
  Frequency: '偵測頻率',
  Status: '點位狀態',
  Value: '數值/單位',
  Level: '告警等級',
  LatestDetectionTime: '最新偵測時間',
  Events: '告警事件累計次數',
  NotificationSwitch: '告警推播開關'
})
// 點位狀態
export const TagStatus = ['-', '異常', '正常']
// 事件狀態
export const EventStatus = ['-', '異常', '正常']
// 管理列表查詢結構
export const managementFilterStructure = [
  {
    label: managementStructure.AssetName,
    name: 'AssetName',
    type: 'input'
  },
  {
    label: managementStructure.Name,
    name: 'Name',
    type: 'input'
  },
  {
    label: managementStructure.AssetPosition,
    name: 'AssetPosition',
    type: 'input'
  },
  {
    label: managementStructure.AssetCategory,
    name: 'AssetCategoryId',
    type: 'cascader',
    options: [],
    value: '',
    isDisable: true
  },
  {
    label: managementStructure.Level,
    name: 'LevelList',
    type: 'multiselect',
    options: arrayToFilterOptions(TagLevelOptionStructure, 1),
    value: ''
  },
  {
    label: managementStructure.Status,
    name: 'StatusList',
    type: 'multiselect',
    options: arrayToFilterOptions(EventStatus),
    value: ''
  }
]
// 設備詳情 -> 實為點位詳情
export const tagDetailStructure = Object.freeze({
  AssetName: managementStructure.AssetName,
  AssetPosition: managementStructure.AssetPosition,
  AssetCategory: managementStructure.AssetCategory,
  Name: managementStructure.Name,
  Mean: managementStructure.Mean,
  Status: managementStructure.Status,
  Frequency: managementStructure.Frequency,
  Value: managementStructure.Value,
  LatestDetectionTime: managementStructure.LatestDetectionTime,
  Events: managementStructure.Events,
  NotificationSwitch: managementStructure.NotificationSwitch,
  EventListByDevice: '告警事件紀錄'
})
// 事件記錄
export const eventListByTagStructure = Object.freeze({

  CreatedTime: '發生時間',
  DoneTime: '結案時間',
  Duration: '持續時間',
  CurrentStageType: '處理狀態',
  CurrentStageRemark: '處理備註'
})
// ---------- TAB 3 ----------
export const logStructure = Object.freeze({

  WarningTime: '偵測時間',
  Status: '點位狀態',
  TagLevel: '告警等級',
  TagMean: '告警訊息',
  AssetCategory: '設備類別',
  TagName: '點位名稱',
  AssetName: '設備名稱',
  AssetPosition: '存放位置'
})
// 管理列表查詢結構
export const logFilterStructure = [
  {
    label: logStructure.AssetName,
    name: 'AssetName',
    type: 'input'
  },
  {
    label: logStructure.TagName,
    name: 'TagName',
    type: 'input'
  },
  {
    label: logStructure.AssetPosition,
    name: 'AssetPosition',
    type: 'input'
  },
  {
    label: logStructure.AssetCategory,
    name: 'AssetCategoryId',
    type: 'cascader',
    options: [],
    value: '',
    isDisable: true
  },
  {
    label: eventStructure.TagLevel,
    name: 'TagLevelList',
    type: 'multiselect',
    options: arrayToFilterOptions(TagLevelOptionStructure, 1),
    value: ''
  },
  {
    label: '發生時間',
    name: 'duration',
    type: 'date',
    value: [lastMonth, today],
    required: true
  }
]
// ---------- 圖表 ----------
export const analysisPeriodOptionsZh = ['日', '週', '月', '年']
// 分析圖表查詢結構
export const analysisFilterStructure = [
  {
    label: logStructure.AssetName,
    name: 'BaDeviceId',
    type: 'select',
    options: [],
    value: '',
    required: true,
    isDisable: true
  },
  {
    label: logStructure.TagName,
    name: 'TagIdList',
    type: 'multiselect',
    options: [],
    value: '',
    isDisable: true
  },
  {
    label: '發生區間',
    name: 'IntervalList',
    type: 'multiselect',
    options: arrayToFilterOptions(analysisPeriodOptionsZh),
    value: ''
  }
]
export const chartBasedColor = ['#4572c4', '#ed7f35', '#aeaeae', '#ffc10a']
export class DoughnutData {
  constructor (labels, data) {
    this.labels = labels
    this.datasets = [
      {
        backgroundColor: data.map((el, i) => {
          return chartBasedColor[i % chartBasedColor.length]
        }),
        data
      }
    ]
  }
}
export class BarData {
  constructor (labels, data) {
    this.labels = labels
    this.datasets = [
      {
        label: '異常',
        backgroundColor: chartBasedColor[0],
        data,
        maxBarThickness: 30
      }
    ]
  }
}
class LineDataset {
  constructor (label, data, color) {
    this.label = label
    this.data = data
    this.backgroundColor = color
    this.borderColor = color
  }
}
export class LineData {
  constructor (labels, rawDatasets) {
    this.labels = labels
    this.datasets = rawDatasets.map((rawDataset, i) => new LineDataset(rawDataset.Label, rawDataset.Data, chartBasedColor[i % chartBasedColor.length]))
  }
}
